import { useState } from 'react'
import AssessmentQue from '../startAssessmentQue/AssessmentQue'
import './startAssessment.scss'
import Button from '../button/Button'
import { useNavigate } from 'react-router-dom'
import { ROUTES_PATH } from '../../utility/constants'
import BreadCrumbs from '../breadcrumb/Breadcrumb'
import { useSelector } from 'react-redux'

function StartAssessment() {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const navigate = useNavigate()
  const { user } = useSelector((state) => state.auth) || {}
  const facultyId = useSelector((state) => state?.auth?.user?.result?.faculty?.facultyId)

  const roleName = user?.result?.userData?.roleName

  const handleSubmit = () => {
    setIsSubmitted(true)
  }

  const breadCrumbsArr = [
    {
      title: 'Ashlynn Curtis',
      link: null,
    },
    {
      title: 'Dashboard',
      link: roleName && roleName == 'faculty' ? ROUTES_PATH.FACULTY_DASHBOARD : ROUTES_PATH.DASHBOARD ,
    },
    {
      title: 'Exam Assessment',
      link: roleName && roleName == 'faculty' ? ROUTES_PATH.FACULTY_EXAM_ASSESSMENT : ROUTES_PATH.EXAM_ASSESSMENT,
    },
    {
      title: 'Exam Result',
      link: ROUTES_PATH.EXAM_RESULT_PARENT,
    },
    {
      title: 'Student Code: US_AT_C01_01',
      link: ROUTES_PATH.EXAM_START_ASSESSMENT,
    },
  ]

  return (
    <div>
      <div className='main-div-start-assessment'>
        <div className='start-exam-assessment-subheader'>
          <div className='tab-subheader'>
          <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            <p className='assessment-header-totalmark'>Total Marks: 46</p>
            </div>
            <Button
              variant='contained'
              className={`btn-Submit_Assessment ${isSubmitted ? roleName == 'faculty' ? navigate(`/exam-assessment/faculty/result/${facultyId}`): navigate(`/exam-assessment/result/${facultyId}`) : ''}`}
              onClick={handleSubmit}
            >
              {isSubmitted ? 'Submitted' : 'Submit Assessment'}
            </Button>
          </div>
        <div className='assessment-que'>
          <AssessmentQue />
        </div>
      </div>
    </div>
  )
}

export default StartAssessment
